import { leaseRegistry } from './lease/registry.js';
import { spaceRegistry } from './space/registry.js';
import { availabilityRegistry } from './availability/registry.js';
import { saleRegistry } from './sale/registry.js';
import { itzaRegistry } from './itza/registry.js';
import { propertyRegistry } from './property/registry.js';
/** Every domain registry. */
export const allRegistries = [leaseRegistry, spaceRegistry, availabilityRegistry, saleRegistry, itzaRegistry, propertyRegistry];
/** Flat list of every rule across all domains. */
export const allRules = allRegistries.flatMap(registry => registry.rules);
/** Look up a rule by its stable id (e.g. 'lease.term.from-dates'). */
export function ruleById(id) {
  return allRules.find(rule => rule.id === id);
}
